var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#AE00B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.892 20.0518C30.9018 19.3007 30.4949 18.6103 29.8341 18.248L14.4363 9.78797C13.7467 9.39818 12.9337 9.44607 12.2838 9.88984C11.622 10.3411 11.2833 11.4153 11.4683 12.1911L12.9057 18.2135C13.0533 18.831 13.606 19.2659 14.2418 19.2631L22.8107 19.2366C23.2495 19.2278 23.6053 19.5836 23.5965 20.0224C23.5952 20.4538 23.2446 20.8044 22.8058 20.8132L14.2288 20.8331C13.5929 20.8343 13.0375 21.2711 12.8861 21.8896L11.3978 27.9359C11.2171 28.6504 11.4232 29.3637 11.9273 29.8679C11.9866 29.9272 12.0533 29.9939 12.1201 30.0457C12.773 30.5494 13.628 30.6137 14.3581 30.2247L29.8081 21.8475C30.4711 21.4959 30.8823 20.803 30.892 20.0518Z",
    fill: "#AE00B9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.792005410bd0f5ce76466e71df5e3e83.svg";
export { ForwardRef as ReactComponent };